import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import {
  HvGlobalActions,
  HvTypography,
  HvGrid,
  HvRadioGroup,
  HvRadio,
} from "@hitachivantara/uikit-react-core";

import { RuleTriggerValues } from "lib/api";
import { useFormikContext } from "formik";
import useStyles from "./styles";

const Trigger: React.FC = () => {
  const { t } = useTranslation("workflowAddEdit");
  const classes = useStyles();
  const { setFieldTouched, setFieldValue, setStatus, values } =
    useFormikContext<WorkflowFormData>();

  const setValueOnForm = useCallback(
    (property: string, selection: string | number | undefined) => {
      setFieldValue(property, selection);
      // clearServerSideErrors
      setStatus({});
    },
    [setFieldValue, setStatus]
  );

  return (
    <HvGrid container className={classes.root}>
      <HvGrid sm={12} item>
        <HvGlobalActions title={t("trigger.title")} variant="section" />
        <HvTypography variant="normalText">
          {t("trigger.description")}
        </HvTypography>
        <HvRadioGroup
          className={classes.radioGroup}
          readOnly
          label={t("trigger.buttonGroupLabel")}
          name={t("trigger.triggerButtonGroupName")}
          value={values.trigger}
        >
          <HvRadio
            label={t("trigger.radioOne")}
            value={RuleTriggerValues.Creation}
            onClick={() => {
              setValueOnForm("trigger", RuleTriggerValues.Creation);
              setFieldTouched("trigger");
            }}
          />
        </HvRadioGroup>
      </HvGrid>
    </HvGrid>
  );
};

export default Trigger;
